import { render, staticRenderFns } from "./tags-hospitalization.vue?vue&type=template&id=349efecb"
import script from "./tags-hospitalization.vue?vue&type=script&lang=js"
export * from "./tags-hospitalization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports